var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { getPublicRowStateProps } from './getPublicRowStateProps';
export var Action;
(function (Action) {
    Action[Action["NoOp"] = 0] = "NoOp";
    Action[Action["HandledCloses"] = 1] = "HandledCloses";
})(Action || (Action = {}));
/**
 * Using the previous expanded state and current expanded state, check if any
 * drawers have closed. If so, then invoke onDrawerClose with the associated row
 * of data.
 *
 * Please note that this function assumes an expanded depth of 1 (i.e. no nested
 * drawers).
 */
export var handleDrawerCloses = function (_a) {
    var drawer = _a.drawer, onDrawerClose = _a.onDrawerClose, expanded = _a.expanded, prevExpanded = _a.prevExpanded, rows = _a.rows;
    if (!drawer || !onDrawerClose || !prevExpanded)
        return Action.NoOp;
    /**
     * Get ids of drawers currently open
     *
     * { '3': true, '5': true, '10': false } => ['3', '5']
     */
    var currentlyOpen = Object.entries(expanded).reduce(function (set, _a) {
        var _b = __read(_a, 2), rowId = _b[0], isOpen = _b[1];
        if (isOpen)
            set.add(rowId);
        return set;
    }, new Set());
    Object.entries(prevExpanded).forEach(function (_a) {
        var _b = __read(_a, 2), rowId = _b[0], wasOpen = _b[1];
        if (wasOpen && !currentlyOpen.has(rowId)) {
            var row = rows[+rowId];
            onDrawerClose(__assign({ data: row.original }, getPublicRowStateProps(row)));
        }
    });
    return Action.HandledCloses;
};
//# sourceMappingURL=handleDrawerCloses.js.map